import { render, staticRenderFns } from "./TechnicalJournal.vue?vue&type=template&id=765fd71a&lang=pug"
import script from "./TechnicalJournal.vue?vue&type=script&lang=js"
export * from "./TechnicalJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports